import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import VehiclesServices from 'services/vehicle/vehicle.service';
import { isValidVehicleId, normalizeVehicleId } from './helpers/vehicles';

const withCancellation = async (signal, request) => {
	const cancelSource = axios.CancelToken.source();
	const cancelRequest = () => cancelSource.cancel();
	if (signal.aborted) cancelRequest();
	else signal.addEventListener('abort', cancelRequest);
	try {
		return await request(cancelSource.token);
	} finally {
		signal.removeEventListener('abort', cancelRequest);
	}
};

export const getVdpVehicleDetails = createAsyncThunk(
	'buyerVehicles/getVdpVehicleDetails',
	async ({ vehicleId, vdpType, query, shouldMarkAsViewed }, { rejectWithValue, signal }) => {
		try {
			const { data } = await withCancellation(signal, (cancelToken) =>
				VehiclesServices.instance.getVehicleDetails(vehicleId, vdpType, query, cancelToken),
			);
			const numericVehicleId = normalizeVehicleId(vehicleId);
			if (!data?.success || normalizeVehicleId(data.vehicle?.id) !== numericVehicleId) {
				return rejectWithValue({
					errorMessage: data?.message || 'Unable to get vehicle details',
					status: data?.status,
				});
			}
			// normalize the vehicle to use same watching and following keys as in the vehicle card context, since the vdp response has different keys
			const { ['watching?']: watching, followed, ...vehicle } = data.vehicle;
			return {
				vehicle: {
					...vehicle,
					id: numericVehicleId,
					...(watching !== undefined ? { watching } : {}),
					...(followed !== undefined ? { following: followed } : {}),
					...(shouldMarkAsViewed ? { viewed: true } : {}),
				},
			};
		} catch (error) {
			return rejectWithValue({
				errorMessage: 'Unable to get vehicle details',
				status: error?.status || error?.response?.status,
			});
		}
	},
	{ condition: ({ vehicleId }) => isValidVehicleId(vehicleId) },
);
